// extracted by mini-css-extract-plugin
export default {"container":"WelcomeInput_container__duMGB","iconContainer":"WelcomeInput_iconContainer__54Fvk","textContainer":"WelcomeInput_textContainer__RWa3C"};